import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

// `suffix` is a server-supplied marker printed after the amount — "+ Fuel costs"
// on a launch estimate whose fill-up has not been pumped yet. The caller decides
// whether a row carries one; this only prints it.
const Tax = ({ label, amount, suffix = null, loading, currency = "USD" }) => {
  return (
    <div className="flex items-center justify-between text-gray-600">
      <span>{label}</span>
      <div className="h-5">
        {loading ? (
          <i className="fa-solid fa-spinner-third fa-spin h-full text-gray-600" />
        ) : (
          <span>
            {formatCurrencyFromMinorUnits({ amount, currency })}
            {suffix ? ` ${suffix}` : null}
          </span>
        )}
      </div>
    </div>
  )
}

Tax.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  suffix: PropTypes.string,
  loading: PropTypes.bool,
  currency: PropTypes.string,
}

export default Tax
